import Xarrow from "react-xarrows";
import { Fragment } from "react";
import { TaskJob } from "./Task";
import { Conditional } from "./Conditional";
import { Parallel } from "./Parallel";
import { Timer } from "./Timers";
import Tippy, { useSingleton } from "@tippyjs/react";

function getJobElement(job, singleton, theme) {
  return (
    <Fragment key={"frag_" + job.id}>
      {job.type === "task" ? (
        <TaskJob job={job} theme={theme} singleton={singleton} />
      ) : job.type === "conditional" ? (
        <Conditional job={job} theme={theme} singleton={singleton} />
      ) : job.type === "parallel" ? (
        <Parallel job={job} theme={theme} singleton={singleton} />
      ) : job.type === "timerEvent" ? (
        <Timer job={job} theme={theme} singleton={singleton} />
      ) : null}
    </Fragment>
  );
}

export function Arrows({ job = {} }) {
  return (
    <div className="arrow_cond" onClick={(e) => e.stopPropagation()}>
      {job.connections.next.map((ids) => (
        <Xarrow
          key={"arrow_" + job.id + "_" + ids}
          color="#111"
          showHead={true}
          strokeWidth={2}
          startAnchor={"right"}
          endAnchor="top"
          path="grid"
          start={job.id} //or an id
          end={"anchor_" + ids} //can be react ref
          zIndex={-500}
        />
      ))}
    </div>
  );
}

export function ChartCell({ jobs, date, theme }) {
  const [source, target] = useSingleton({ overrides: ["followCursor"] });
  let jobElements = jobs.map((job) =>
    getJobElement(job, [source, target], theme)
  );
  return (
    <div
      style={{
        position: "relative",
        backgroundColor:
          date.getDay() === 0 || date.getDay() === 6 ? "whitesmoke" : "white",
      }}
      className="gantt-row-item"
    >
      {jobElements}
      <Tippy
        singleton={source}
        delay={1000}
        arrow={true}
        // Uncomment for transitions!
      />
    </div>
  );
}
